
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import banner from '@/assets/answer/banner.png'
import config from '@/config'
import { getExam, save, getview,addCreditParty,addAddress2,relation,addPartyCount } from '@/api/jfhl.js'
import { isAward, isAwardbefore,updateuser } from '@/api/lottery'
import { getAddressDefault,operateCreditlist } from '@/api/user'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getRequest } from '@/libs/utils.js'
import {getaddlog } from '@/api/hgfw'
export default {
directives: {
TransferDom
},
name: 'ruleIndex',
components: {
},
data () {
return {
openbg:openbg,
banner:banner,
partyid:this.$route.params.partyid,
paperInfoid:'',
showAddress:false,
prize:'',
personObj:{
NAME:'',
ADDRESS:'',
MOBILE:''
},
owner_type: config.owner_type,
start:1,
isbutton:false
}
},
components: {
XDialog,
XButton,
Group,
XInput
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch:{
},
mounted() {
this.getAdd()
this.view()
this.addIntegral()
this.addcount()
},
methods:{
getAdd(){
getaddlog({
accountid:this.accountid,
moduleid: 1200,
submoduleid: 120107
}).then(res=>{
})
},
addcount(){
addPartyCount({
partyid:this.partyid,
accoutid:this.accountid,
credittype:1
}).then(res => {
})
},

view(){
getview({
id: this.partyid
}).then(res=>{
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.beforeAward()
})
},

isCurrentTime2(beginTime,endTime){
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if(currentTime < beginTime){
this.start = 1
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始',
})
this.isbutton = true
return false
}
if(currentTime >= endTime){
this.start = 1
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束',
})
this.isbutton = true
return false
}
this.isbutton = false
this.start=2

},

isCurrentTime(beginTime,endTime){
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if(currentTime < beginTime){
this.start = 1
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始',
})
this.isbutton = true
return false
}
if(currentTime >= endTime){
this.start = 1
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束',
})
this.isbutton = true
return false
}
this.isbutton = false
this.start=2
this.isawardNow()
this.getAddress()


},

beforeAward(){
isAwardbefore({
lotid:this.lotid,
openid:this.userid
}).then(res=>{
if(res.obj.iszhongjiang===1){
if(res.obj.item.indexOf("积分") == -1){
this.prize = res.obj.item
if(res.obj.partyuserid==="" ){
this.showAddress = true
}else{
this.showAddress = false
}

}else{
this.showAddress = false
}
this.isCurrentTime2('2019/11/09', '2019/11/11')
}else{
this.isCurrentTime('2019/11/09', '2019/11/11')
}
})
},

isawardNow(){
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if ((data.obj.isaward === 1 && data.obj.iszhongjiang === 1) && data.obj.item.indexOf("积分") == -1) {
this.prize = data.obj.item
this.isAddress()
}else{
this.showAddress = false
}
})
},

getAddress(){
getAddressDefault({
accountid:this.accountid,
userid:this.userid
}).then(res=>{
if(res.returnValue!==""){
this.personObj = res.returnValue
this.personObj.ADDRESS = res.returnValue.PROVINCEIDNAME+res.returnValue.CITYIDNAME+res.returnValue.COUNTYIDNAME+res.returnValue.ADDRESS
}
})
},

goAnswer(){
this.getExam()
},
goAnswer2(){
this.$vux.alert.show({
content: '该时间段不能参与抽奖活动',
})
},

getExam() {
let _this = this
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.toast.text('您今天的一次答题机会已用完请明天再来')
return false
}else{
this.$router.push({name:'answerLottery',params:{partyid:this.partyid}})
}
})
},

isAddress(){
updateuser({
lotid:this.lotid,
openid:this.userid
}).then(res=>{
if(res.obj.isaddress===2){
this.showAddress = true
}else{




}
})
},

sumbit(){
if(this.personObj.NAME===''){
this.$vux.toast.text('请填写姓名！')
return false
}
if(this.personObj.ADDRESS===''){
this.$vux.toast.text('请填写收货地址！')
return false
}
if(this.personObj.MOBILE===''){
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
addAddress2({
userid:this.accountid,
partyid:this.partyid,
linkman:this.personObj.NAME,
phone:this.personObj.MOBILE,
address:this.personObj.ADDRESS
}).then(res=>{
this.showAddress = false
if(res.success){

relation({
partyuserid:res.obj.partyuserid,
lotid:this.lotid,
userid:this.accountid,
openid:this.userid
}).then(data=>{
if(data.success){
this.showAddress = false
this.$vux.toast.text('您的信息提交成功！')

}
})
}
}).catch(()=>{
this.showAddress = false
})
},

addIntegral(credit){
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit:5,
owner_type: this.owner_type,
relationtype: 2,
relationid: this.partyid,
terminaltype: 2
}).then(res => {})







},
},
created () {
}
}
